import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InotificationItem, NotificationService } from 'app/services/notification/notification.service';

@Component({
  selector: 'notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NotificationsComponent implements OnInit {

  notificationItems: InotificationItem[];
  numberUnreadNotification: number;

  constructor(private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.notificationService.checkNotification().subscribe();
    this.notificationService.notificationItems$.subscribe(items => this.notificationItems = items);
    this.notificationService.numberUnreadNotification$.subscribe(number => this.numberUnreadNotification = number);
  }

  openNotificationPanel() {
    this.notificationService.setNotificationRead();
  }

}
